import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { ImportAnnotationsBl } from '../../../importAnnotations.bl';
import { IImportAnnotationsStore } from '../../../importAnnotations.store';
import { ImportAnnotationsStep } from '../../../models/ImportAnnotationsSteps';
import { SummaryStepModal } from './SummaryStepModal';

export const SummaryStepContainer = observer((): ReactElement => {
  const bl = useInjection(ImportAnnotationsBl.$);
  const store = useInjection(IImportAnnotationsStore.$);

  const handleHide = (): void => {
    bl.finishImport();
  };

  const isCurrentStep = store.currentStep === ImportAnnotationsStep.Summary;

  return (
    <SummaryStepModal
      onHide={handleHide}
      show={isCurrentStep}
    />
  );
});
